import {closeCurrentDialog, showNotification} from 'platform/components';

import {isNotNil} from 'ramda-adjunct';

import {useCreateTaskMutation} from '@dms/api/core';
import i18n from '@dms/i18n';
import {getTeamId, handleApiError, isTeamValue} from '@dms/shared';

import {getApiDateString, parseDate, RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {TaskForm as TaskFormType} from '../../types/TaskForm';
import {TaskFormInput} from '../../types/TaskFormInput';
import {TaskRelationProps} from '../../types/TaskRelationProps';
import {castTimeToDateISOString} from '../../utils/castTimeToDateISOString';
import {TaskForm} from '../TaskForm/TaskForm';

interface CreateTaskFormProps extends RequiredTestIdProps, TaskRelationProps {
  values?: TaskFormInput;
  onCreate?: () => void;
}

export function CreateTask(props: CreateTaskFormProps) {
  const [createTask] = useCreateTaskMutation();

  const onCreateTask = (data: TaskFormType) => {
    const teamId = isTeamValue(data.assignedTo) ? getTeamId(data.assignedTo) : null;

    return createTask({
      createTaskRequestBody: {
        ...data,
        assignedTo: teamId ?? data.assignedTo,
        assignToTeam: isNotNil(teamId),
        dueDate: data?.dueDate ? getApiDateString(parseDate(data.dueDate)) : null,
        dueFrom:
          data?.dueDate && data?.dueFrom
            ? castTimeToDateISOString(data.dueDate, data.dueFrom)
            : null,
        dueTo:
          data?.dueDate && data?.dueTo ? castTimeToDateISOString(data.dueDate, data.dueTo) : null,
      },
    })
      .unwrap()
      .then(() => {
        showNotification.success(i18n.t('general.notifications.successfullyCreated'));
        closeCurrentDialog();
        props.onCreate?.();
      })
      .catch(handleApiError);
  };

  return (
    <TaskForm
      isCreateTask
      onSubmit={onCreateTask}
      data-testid={suffixTestId('createTask', props)}
      relatedRecordId={props.relatedRecordId}
      resourceId={props.resourceId}
      values={props.values}
    />
  );
}
